import { DashboardActivateAccountPage } from "@dashboard/components/activation/ActivateAccountPage"
import { dashboardAppHostRedirectUrl } from "@dashboard-config/dashboard-host"
import { currentRequestHostname } from "@dashboard-config/dashboard-host-runtime"
import { createFileRoute, redirect } from "@tanstack/react-router"

type ActivateAccountSearch = {
  email?: string
  token?: string
}

export const Route = createFileRoute("/activate-account")({
  validateSearch: (search): ActivateAccountSearch => ({
    email: typeof search.email === "string" ? search.email : undefined,
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
  component: ActivateAccountRoute,
})

function ActivateAccountRoute() {
  const search = Route.useSearch()
  return (
    <DashboardActivateAccountPage
      email={search.email}
      token={search.token}
    />
  )
}
